module.exports = __webpack_public_path__ + "static/media/background.93fbc39a.svg";